import './social.scss';
import React, { Component } from 'react';
import SocialProfileManager from './SocialProfileManager';
import SocialTabsManager from './SocialTabsManager';
import Translator from './../../requests/apa/Translator';

class Social extends Component {

  constructor(props) {
    super(props);

    this.state = {
        userSocial: props.userSocial,
        isCurrentUser: props.isCurrentUser,
        gameId: props.gameId,
        emails: props.emails,
        gamificationIdUserlogged: props.gamificationIdUserlogged,
    }

  }



  render() {
      if(!this.state.userSocial) {
        return null;
      }

      let emails = [];
      if(!Array.isArray(this.state.social) && this.state.social != undefined)
          emails.push(this.state.social);
      else
          emails = Object.assign([], this.state.social);

      return(<div className="social">
          <SocialProfileManager
              translations={Translator}
              userSocial={this.state.userSocial}
              user={this.props.user}
              gameId={this.state.gameId}
              isCurrentUser={this.state.isCurrentUser}
              ownFollowings={ this.props.ownFollowings }
              gamificationIdUserlogged={this.state.gamificationIdUserlogged}
              incOwnFollowings={ this.props.incOwnFollowings }
              decOwnFollowings={ this.props.decOwnFollowings }
              nameFromisloggedin={this.props.nameFromisloggedin}
          />
          <div className="tabs">
              <SocialTabsManager
                getLinks={this.props.getLinks}
                userSocial={this.state.userSocial}
                translations={Translator}
                gameId={this.state.gameId}
                gamificationId={this.state.userSocial.id}
                isCurrentUser={this.state.isCurrentUser}
                messages={ emails }
                ownFollowings={ this.props.ownFollowings }
                gamificationIdUserlogged={this.state.gamificationIdUserlogged}
                incOwnFollowings={ this.props.incOwnFollowings }
                decOwnFollowings={ this.props.decOwnFollowings }
                showModal={this.props.showModal}
                setMetricsEvent={this.props.setMetricsEvent}
                user={this.props.user}
              />
          </div>
      </div>)
  }

}

export default Social



// WEBPACK FOOTER //
// ./src/containers/Social/index.jsx